import React from 'react';
import classNames from 'classnames/bind';
import { calculateSize } from '../../../../data/paint-modals';
import styles from './Footer.module.scss';

const cx = classNames.bind(styles);
export const Footer = () => {

  return (
    <div className={cx('footer-disclaimer')}>
      PLEASE NOTE: {calculateSize.disclaimer}
    </div>
  );
};

Footer.displayName = 'Footer';
